module.exports = __webpack_public_path__ + "img/tv01-black.a8503cba.jpg";